import {
  buildFormData,
  overParseJson,
  checkAttendantAndFetch,
} from '../utils/requestUtils';

const NEWS_API_URL = 'https://afiliados.uol.com.br/api/news.html';
const NEWS_LIST_API_URL = 'https://afiliados.uol.com.br/api/selectNews.html';
const HTTP_ERROR = 'HTTP_ERROR';
const DEFAULT_FETCH_OPTIONS = {
  credentials: 'same-origin',
};

class NewsApi {
  static buildNewsPayload(newsOptions) {
    return {
      ajax: true,
      'newsRequest.idtCommEventSourceGroup': newsOptions.idtCommEventSourceGroup,
      'newsRequest.qtd': newsOptions.qtd,
      'newsRequest.hasImages': newsOptions.hasImages,
      'newsRequest.firstRow': newsOptions.firstRow,
      'newsRequest.excludedIdtNews': newsOptions.excludedIdtNews,
    };
  }

  static async getNews(newsId) {
    try {
      const fetchResponse = await checkAttendantAndFetch(`${NEWS_API_URL}?idtAffCampaginNews=${newsId}`, {
        method: 'GET',
        credentials: 'same-origin',
      });
      const text = await fetchResponse.text();
      const data = overParseJson(text);

      if (fetchResponse.status !== 200) {
        const error = new Error(data.error);
        error.code = HTTP_ERROR;
        error.status = fetchResponse.status;
        throw error;
      }

      return data;
    } catch (error) {
      throw error;
    }
  }

  static async getNewsList(newsOptions) {
    try {
      const payload = buildFormData(this.buildNewsPayload(newsOptions));
      const fetchResponse = await checkAttendantAndFetch(NEWS_LIST_API_URL, {
        method: 'POST',
        body: payload,
        ...DEFAULT_FETCH_OPTIONS,
      });
      const text = await fetchResponse.text();
      const data = overParseJson(text);

      if (fetchResponse.status !== 200) {
        const error = new Error(data.error);
        error.code = HTTP_ERROR;
        error.status = fetchResponse.status;
        throw error;
      }
      return data;
    } catch (error) {
      throw error;
    }
  }
}

export default NewsApi;
